import React from 'react';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        justifyContent: 'center',
        border: `solid 1px ${palette.border.primary}`,
        borderRadius: '24px',
        display: 'flex',
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
        '& p': {
            marginBottom: 0,
            marginTop: 0,
        },
    },
}));

function BuenosAiresSpanishGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_buenos_aires`,
        classes.root,
    );

    return (
        <div className={rootClassNames}>
            <div className={`${BEM_BLOCK_NAME}--giving_instructions_buenos_aires_inner`}>
                <strong>Transferencia Bancaria</strong>
                <p>CUIT: 30-71428192-1</p>
                <p>CBU: 0720087820000001443486</p>
                <p>{`Comentario: ${campaignName}`}</p>
            </div>
        </div>
    );
}

export default BuenosAiresSpanishGivingInstructions;
